import { Communications } from './Communications'
import { Notes } from './Notes'
import { Transactions } from './Transactions'
import { Vouchers } from './Vouchers'

import { isGenericClient, isWFClient, isWWClient, isHampstaClient } from 'setups/controller'
import { projectClient } from 'constants/project'

const Dashboard = (): JSX.Element => (
  <div className="grid w-full grid-cols-1 gap-4 p-4 lg:grid-cols-2">
    <Transactions />
    <Communications />
    {!(isGenericClient(projectClient) || isWFClient(projectClient) || isWWClient(projectClient) || isHampstaClient(projectClient)) && <Vouchers />}
    <Notes />
  </div>
)
export default Dashboard
